module.exports = __webpack_public_path__ + "img/05.3274a7a0.png";